import axios from '../../utils/http/http';
import { triggerNotification } from '../../utils/NotificationContext';
const flow = 'BulkVoting';

export const fetchDecisionData = async (bu, userId, level, pageNo, perPageRowCount, cycleId) => {
  try {
    let response = await axios.getRequest(
      `/tpo/voting/getTPOSKUBusinessLevel/${encodeURIComponent(bu)}/${userId}/${level}/${pageNo}/${perPageRowCount}?cycleId=${cycleId}`
    );
    if (typeof response === 'string') {
      triggerNotification(response, 'error');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUsers = async (BU, userLevel) => {
  try {
    const response = await axios.getRequest(`/tpo/voting/getBUUsers/${encodeURIComponent(BU)}/${userLevel}`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
export const fetchRecommendationOptions = async (BU) => {
  try {
    const response = await axios.getRequest(`/tpo/voting/getRecommendation/${encodeURIComponent(BU)}`);

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const saveDecisionData = async (obj) => {
  try {
    const response = await axios.postRequest(`/tpo/voting/addDecision`, obj);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
export const saveCompletionData = async (obj) => {
  try {
    const response = await axios.postRequest(`/tpo/voting/addDecisionCompletion`, obj);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Upload APIs for Voting

export const bulkUploadFile = async (formData, onUploadProgress, region = null) => {
  try {
    const API_BASE_URL = '/tpo/voting/bulkupload';
    const response = await axios.postRequest(API_BASE_URL, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress
    });
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Bulk Upload Failed!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUploadsInProgress = async (selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/bulkUpload/uploadStatusByFlow/${flow}?buName=${encodeURIComponent(selectedBu)}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUploadsInProgressByUserId = async (userName, selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/bulkUpload/uploadStatus/${userName}?buName=${encodeURIComponent(selectedBu)}&flow=${flow}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
